import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Modal, Select, SelectChangeEvent, TextField } from '@mui/material'
import React, { useState } from 'react'
import { openPopup } from '../../stateManagement/actions/popupActions';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import CloseIcon from '@mui/icons-material/Close';
import { getAccessToken } from '../../services/authenticationService';

interface Props {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    registrationData: any[]
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


function SPMetadataGenerator({ open, setOpen, registrationData }: Props) {

    const [selectedId, setSelectedId] = React.useState<string | null>(null);
    const [entity, setEntity] = useState<string>("");

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedId(event.target.value);
    };

    const options = registrationData.map((data) => {
        if (data.extras.type === "IDP") return data.registrationId;
    })

    const handleGenerate = () => {
        try {
            if (entity.trim() === "") {
                openPopup("Alert", "Entity field cannot be empty");
                return;
            }

            if (selectedId === null) {
                openPopup("Alert", "Select a Registration ID");
                return;
            }
            const serverUrl = EnvironmentRegistry.getServerUrl();
            const token = getAccessToken();
            window.open(serverUrl + "/v1/sso/saml/spmetadata?entityid=" + entity + "&name=" + selectedId + "&target=" + serverUrl + "&access_token=" + token, 'winname', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
        } catch (error) {
            console.error(error);
            openPopup("Error", "Error while generating SP METADATA");
        }
    }

    return (
        <Modal
            open={open}
            onClose={() => { setOpen(false) }}
        >
            <Box sx={style}>
                <IconButton onClick={() => setOpen(false)} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                    <CloseIcon />
                </IconButton>
                <FormControl sx={{mt:'30px'}}>
                    <InputLabel id="demo-select-small-label">Registration ID</InputLabel>
                    <Select
                        // value={age}
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        label="Registration ID"
                        onChange={handleChange}
                    >
                        {
                            options.map((item) => <MenuItem value={item}>{item}</MenuItem>)
                        }
                    </Select>
                </FormControl>
                <TextField placeholder='Enter service provider entity id' onChange={(e) => setEntity(e.target.value)} />
                <Button variant={"contained"} onClick={handleGenerate}>Generate</Button>
            </Box>
        </Modal>
    )
}

export default SPMetadataGenerator